import Notiflix from "notiflix";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Space,
  Spin,
  Table,
  Tooltip,
  Typography,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import {
  DeleteOutlined,
  DollarOutlined,
  EditOutlined,
  FlagOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import styles from "../../../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../../../components/CheckerModal";
import { accountStatus } from "../../../../../components/facilities/AccountFacility";
import cnt from "../../../../../services/definedConstant";
import { BOM } from "../../../../../services/definedMethod";
import { apiConfig, labelConfig } from "../wallet.config";

const Charges = (props) => {
  const {
    chargesList,
    state,
    userData,
    refreshDetail,
    refreshNote,
    walletAccountDetails,
  } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleChargeDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.name, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        // Yes
        const url = `${apiConfig.WalletAccount}/${state.id}/charges/${key.id}`;

        const body = {
          method: "DELETE",
          session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteChargeMsg);
              //refresh the list
              refreshDetail();
              refreshNote();
              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              refreshDetail();
              refreshNote();
              //STOP LOAD

              setIsLoading(false);
            },
          }
        );
      },
      function () {
        // No button
      }
    );
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Payment due at",
      dataIndex: "paymentDueAt",
    },
    {
      title: "Calculation Type",
      dataIndex: "calculationType",
    },
    {
      title: "Due",
      dataIndex: "due",
    },
    {
      title: "Paid",
      dataIndex: "paid",
    },
    {
      title: "Waived",
      dataIndex: "waived",
    },
    {
      title: "Outstanding",
      dataIndex: "outstanding",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Actions",
      render: (_, record) =>
        state?.statusValue?.toLowerCase() ===
        accountStatus.submittedAndPending ? (
          <>
            <DetailCharge
              currentCustomerObj={state}
              userData={userData}
              chargeObj={record}
              refreshDetail={refreshDetail}
              refreshNote={refreshNote}
              walletAccountObj={walletAccountDetails}
            />
            &nbsp;
            {BOM.HasPermission("UPDATE_SAVINGSACCOUNTCHARGE") && (
              <EditCharge
                currentCustomerObj={state}
                userData={userData}
                chargeObj={record}
                refreshDetail={refreshDetail}
                refreshNote={refreshNote}
              />
            )}
            &nbsp;
            {BOM.HasPermission("DELETE_SAVINGSACCOUNTCHARGE") && (
              <Tooltip title={`Remove Charge`}>
                <Button
                  type="primary"
                  icon={<DeleteOutlined />}
                  onClick={() => handleChargeDelete(record)}
                  shape="round"
                  size="small"
                  className="detail-btn"
                  style={{
                    backgroundColor: "#FDF4FF",
                    border: "none",
                    color: "#ba24d5",
                  }}
                />
              </Tooltip>
            )}
          </>
        ) : state?.statusValue?.toLowerCase() === accountStatus.approved ? (
          <DetailCharge
            currentCustomerObj={state}
            userData={userData}
            chargeObj={record}
            refreshDetail={refreshDetail}
            refreshNote={refreshNote}
            walletAccountObj={walletAccountDetails}
          />
        ) : (
          <>
            <DetailCharge
              currentCustomerObj={state}
              userData={userData}
              chargeObj={record}
              refreshDetail={refreshDetail}
              refreshNote={refreshNote}
              walletAccountObj={walletAccountDetails}
            />
            &nbsp;
            {BOM.HasPermission("PAY_SAVINGSACCOUNTCHARGE") &&
              !(
                record?.amountWaived > 0 && record?.amountOutstanding === 0
              ) && (
                <PayCharge
                  currentCustomerObj={state}
                  userData={userData}
                  chargeObj={record}
                  refreshDetail={refreshDetail}
                  refreshNote={refreshNote}
                />
              )}
          </>
        ),
    },
  ];

  return (
    <Table columns={columns} dataSource={chargesList} scroll={{ x: 800 }} />
  );
};

export default Charges;

const DetailCharge = (props) => {
  const {
    currentCustomerObj,
    userData,
    chargeObj,
    refreshDetail,
    refreshNote,
    walletAccountObj,
  } = props;

  const { session } = userData;
  const [useForm] = Form.useForm();
  const navigate = useNavigate();
  const [inputField, setInputField] = useState([]);
  const [chargeDetail, setChargeDetail] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getDetailById = () => {
    const url = `${apiConfig.WalletAccount}/${walletAccountObj.id}/charges/${chargeObj.id}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res?.savingsCharge;
        setChargeDetail(objDetail);

        setInputField([
          {
            name: labelConfig.name,
            value: objDetail?.name
              ? BOM.SubstringFormat(objDetail?.name, 20)
              : "-",
            type: "general",
          },
          {
            name: labelConfig.charge,
            value: objDetail?.penalty ? "Penalty" : "Fees",
            type: "general",
          },

          {
            name: labelConfig.currency,
            value: objDetail?.currency ? objDetail?.currency?.name : "-",
            type: "general",
          },
          {
            name: labelConfig.paymentDueAt,
            value: objDetail.chargeTimeType
              ? objDetail.chargeTimeType?.value
              : "-",
            type: "general",
          },
          {
            name: labelConfig.paymentDueAsOf,
            value: objDetail.paymentDueAsOf
              ? objDetail.paymentDueAsOf.value
              : "-",
            type: "general",
          },

          {
            name: labelConfig.calculationType,
            value: objDetail?.chargeCalculationType
              ? objDetail?.chargeCalculationType?.value
              : "-",
            type: "general",
          },
          {
            name: labelConfig.due,
            value: `${
              objDetail?.currency?.code ? objDetail?.currency?.code : "-"
            } ${
              objDetail?.amountOrPercentage
                ? objDetail?.amountOrPercentage
                : "0.00"
            }`,
            type: "general",
          },
          {
            name: labelConfig.paid,
            value: `${
              objDetail?.currency?.code ? objDetail?.currency?.code : "-"
            } ${objDetail?.amountPaid ? objDetail?.amountPaid : "0.00"}`,
            type: "general",
          },
          {
            name: labelConfig.waived,
            value: `${
              objDetail?.currency?.code ? objDetail?.currency?.code : "-"
            } ${objDetail?.amountWaived ? objDetail?.amountWaived : "0.00"}`,
            type: "general",
          },
          {
            name: labelConfig.outstanding,
            value: `${
              objDetail?.currency?.code ? objDetail?.currency?.code : "-"
            } ${
              objDetail?.amountOutstanding
                ? objDetail?.amountOutstanding
                : "0.00"
            }`,
            type: "general",
          },
        ]);

        setIsLoading(false);
      }
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
    getDetailById();
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  function handleWaiveCharge() {
    let action = "Waive  ";
    let label = chargeDetail.name;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        const params = {
          command: "waive",
        };
        const url = `${apiConfig.WalletAccount}/${currentCustomerObj.id}/charges/${chargeDetail.id}`;
        const body = {
          method: "POST",
          dateFormat: "dd MMMM yyyy",
          locale: "en",
          session,
          params,
        };

        setIsLoading(true);

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.waivedChargeMsg);
              setIsModalOpen(false);
              refreshDetail();
              refreshNote();

              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              setIsModalOpen(false);
              refreshDetail();
              refreshNote();

              setIsLoading(false);
            },
          }
        );
      },
      function () {
        // No button
      }
    );
  }

  return (
    <>
      <Tooltip title={`View Detail`}>
        <Button
          type="primary"
          icon={<FolderOpenOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="detail-btn"
          style={{
            backgroundColor: "#FDF4FF",
            border: "none",
            color: "#ba24d5",
          }}
        />
      </Tooltip>
      <Modal
        title="Charge Detail"
        centered
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={800}
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Form layout="vertical" form={useForm}>
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Space size="small">
                {/* {currentCustomerObj.statusValue.toLowerCase() ===
                accountStatus.active
                  ? BOM.HasPermission("WAIVE_SAVINGSACCOUNTCHARGE") && (
                      <Button
                        type="primary"
                        shape="round"
                        icon={<FlagOutlined />}
                        className="of-primaryBtnColor"
                        onClick={() => handleWaiveCharge(chargeDetail)}
                        danger={true}
                      >
                        Waive Charge
                      </Button>
                    )
                  : null} */}
                {currentCustomerObj?.statusValue?.toLowerCase() ===
                  accountStatus.active &&
                !(
                  chargeDetail?.amountPaid > 0 &&
                  chargeDetail?.amountOutstanding === 0
                )
                  ? BOM.HasPermission("WAIVE_SAVINGSACCOUNTCHARGE") && (
                      <Button
                        type="primary"
                        shape="round"
                        icon={<FlagOutlined />}
                        className="of-primaryBtnColor"
                        onClick={() => handleWaiveCharge(chargeDetail)}
                        danger={true}
                      >
                        Waive Charge
                      </Button>
                    )
                  : null}

                {/* {currentCustomerObj.statusValue.toLowerCase() ===
                accountStatus.active
                  ? BOM.HasPermission("INACTIVATE_SAVINGSACCOUNTCHARGE") && (
                      <Button
                        type="primary"
                        shape="round"
                        className="of-primaryBtnColor"
                      >
                        Inactivate Charge
                      </Button>
                    )
                  : null} */}
              </Space>
            </div>
            <Row>
              <Divider orientation="left">{labelConfig.generalInfo}</Divider>
              {inputField.map(
                (item, index) =>
                  item?.type?.toLowerCase() === "general" && (
                    <Col key={index} span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={item.name}>
                        <Input
                          disabled
                          value={item.value}
                          className="of-bold-disable-input"
                        />
                      </Form.Item>
                    </Col>
                  )
              )}
            </Row>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};

const PayCharge = (props) => {
  const {
    currentCustomerObj,
    userData,
    chargeObj,
    refreshDetail,
    refreshNote,
  } = props;

  const { session } = userData;
  const { Text } = Typography;
  const { TextArea } = Input;

  const [useForm] = Form.useForm();
  const [inputField, setInputField] = useState([]);
  const [chargesList, setChargesList] = useState([]);
  const [chargeDetail, setChargeDetail] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getTemplate = () => {
    const params = {
      command: "paycharge",
    };

    const url = `${apiConfig.WalletAccount}/${currentCustomerObj.id}/charges/${chargeObj.id}`;

    let body = {
      session,
      params,
    };
    setIsLoading(true);

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempArray = [];
        setChargeDetail(objList);

        useForm.setFieldsValue({
          amount: objList.amountOutstanding,
        });

        setIsLoading(false);
      }
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
    getTemplate();
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onPayCharge = (formValues) => {
    formValues.dueDate = formValues.dueDate
      ? BOM.DateTime(formValues.dueDate, "only-date")
      : formValues.dueDate;

    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
    };

    // console.log(body);
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      `${apiConfig.WalletAccount}/${currentCustomerObj.id}/charges/${chargeObj.id}?command=paycharge`,
      (err, res) => {
        if (err) {
          // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.payChargeMsg);
          // close modal
          setIsModalOpen(false);

          //refresh the list
          refreshDetail();
          refreshNote();

          //STOP LOAD
          setIsLoading(false);
        }
      }
    );
  };

  return (
    <>
      <Tooltip title={`Pay Charge`}>
        <Button
          type="primary"
          icon={<DollarOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="detail-btn"
          style={{
            backgroundColor: "#FDF4FF",
            border: "none",
            color: "#ba24d5",
          }}
        />
      </Tooltip>
      <Modal
        title="Pay Charge"
        open={isModalOpen}
        okText="Pay"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmitLimit}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm} onFinish={onPayCharge}>
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row style={{ justifyContent: "space-betwen" }}>
            <Divider orientation="left">{labelConfig.chargeInfo}</Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="amount"
                label={<Text>{labelConfig.amount}</Text>}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.amount),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="dueDate"
                label={<Text>{labelConfig.paymentDate}</Text>}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.paymentDate),
                  },
                ]}
              >
                <DatePicker style={{ width: "100%", height: 35 }} />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item name="note" label={<Text>{labelConfig.note}</Text>}>
                <TextArea
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.note)}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};

const EditCharge = (props) => {
  const {
    currentCustomerObj,
    userData,
    chargeObj,
    refreshDetail,
    refreshNote,
  } = props;

  const { session } = userData;
  const { Text } = Typography;
  const { TextArea } = Input;

  const [useForm] = Form.useForm();
  const [inputField, setInputField] = useState([]);
  const [chargesList, setChargesList] = useState([]);
  const [chargeDetail, setChargeDetail] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getTemplate = () => {
    const url = `${apiConfig.WalletAccount}/${currentCustomerObj.id}/charges/${chargeObj.id}`;

    let body = {
      session,
    };
    setIsLoading(true);

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempArray = [];
        setChargeDetail(objList);

        useForm.setFieldsValue({
          amount: objList.amount,
        });

        setIsLoading(false);
      }
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
    getTemplate();
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onEditCharge = (formValues) => {
    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "PUT",
      session,
    };

    // console.log(body);
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      `${apiConfig.WalletAccount}/${currentCustomerObj.id}/charges/${chargeObj.id}`,
      (err, res) => {
        if (err) {
          // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.editChargeMsg);
          // close modal
          setIsModalOpen(false);

          //refresh the list
          refreshDetail();
          refreshNote();

          //STOP LOAD
          setIsLoading(false);
        }
      }
    );
  };

  return (
    <>
      <Tooltip title={`Edit Charge`}>
        <Button
          type="primary"
          icon={<EditOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="detail-btn"
          style={{
            backgroundColor: "#FDF4FF",
            border: "none",
            color: "#ba24d5",
          }}
        />
      </Tooltip>
      <Modal
        title="Edit Charge"
        open={isModalOpen}
        okText="Submit"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmitLimit}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm} onFinish={onEditCharge}>
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row style={{ justifyContent: "space-betwen" }}>
            <Divider orientation="left">{labelConfig.chargeInfo}</Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="amount"
                label={<Text>{labelConfig.amount}</Text>}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.amount),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};
